import type { DrugResultV2 } from '../types';

/**
 * Flatten nested HA documents into the pre-unification `sba` run-report row
 * shape (one row per document) so "Use in CEPI" capture
 * (`cepi_result_capture._row_sba`, `shell/runResults.countRows('cogni', _, 'sba')`)
 * keeps working for multi_review runs. FE-only; no backend change (Plan D4).
 */
export function haDocumentsToSbaRows(drugResults: DrugResultV2[] | null | undefined) {
  const rows: Array<Record<string, unknown>> = [];
  for (const drug of drugResults ?? []) {
    for (const doc of drug.ha_documents ?? []) {
      rows.push({
        drug_id: drug.drug_id,
        document_id: doc.document_id,
        doc_type: doc.doc_type ?? null,
        trade_name: drug.drug_name,
        applicant: drug.manufacturer ?? null,
        score: drug.score,
        submission_status_date: doc.submission_status_date ?? null,
        evidence_sections: doc.evidence,
      });
    }
  }
  return rows;
}
